import React from "react";
import {ErrorMessage, Field} from "formik";

const InputField = (props) => {
    const {name, id, type, label, hidden, required, ...rest} = props;

    if (type === "checkbox") {
        return (
            <div className="flex space-x-3 items-center">
                <Field name={name} id={id} type={type} {...rest} className='checkbox-label'/>
                <label htmlFor={label} className={`${hidden ? "hidden " : ""} checkbox-label`}>
                    <span className={`${required ? 'after:content-["*"] after:text-red-600/70' : ""}`}>{label}</span>
                </label>
            </div>
        );
    }

    return (
        <div className="flex flex-col space-y-1 items-start w-full">
            <label htmlFor={label} className={`${hidden ? "hidden " : ""} form-label`}>
                <span className={`${required ? 'after:content-["*"] after:text-red-600/70' : ""}`}>{label}</span>
            </label>
            <Field name={name} id={id} type={type} {...rest}
                   className={type === 'textarea' ? "form-txtarea" : "form-input"}/>
            <ErrorMessage name={name} component={ErrorText}/>
        </div>
    );
};

export default InputField;

export const ErrorText = ({children}) => {
    return <span className="text-red-600 font-semibold">{children} !</span>;
};
